import React, { ReactElement } from 'react';
import { Header } from '../../../routes/project/project.page';
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb';

import styles from './setting-screen-layout.module.scss';
interface SettingScreenProps extends React.PropsWithChildren {
  title: string;
  className?: string;
  actions?: ReactElement | ReactElement[];
  onBack?: () => void;
}

export const SettingScreenLayout: React.FC<SettingScreenProps> = ({
  children,
  title,
  className,
  actions,
  onBack,
}) => {
  return (
    <div className={className ? `${styles['wrapper']} ${className}` : styles['wrapper']}>
      <Header>
        {!onBack ? (
          <div>{title}</div>
        ) : (
          <Breadcrumb
            breadcrumbs={[
              {
                href: '../billings',
                label: 'Billing',
              },
              {
                href: '',
                label: 'Billing history',
              },
            ]}
          />
        )}
        {actions}
      </Header>

      <div className={styles['screen']}>{children}</div>
    </div>
  );
};
